module.exports = __webpack_public_path__ + "img/favorite.ef4d2078.png";